import React, { Fragment, useState, useEffect } from "react";
import { Image, Button, Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  NewInputText,
  NewSelectBoxInput,
} from "../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import SVG from "react-inlinesvg";
import { ITEMTYPEVEG } from "../../../../enums/OrderEnums";
import isEmpty from "../../../../store/validation/is-Empty";
import { ReadMore } from "../../../superAdminComponents/superAdminAllComponent/superAdminOffers/SuperAdminOffers";

const ItemDescModelBody = (props) => {
  const getSizes = () => {
    let sizeName = [];
    for (let i = 0; i < props.item.size.length; i++) {
      sizeName.push(props.item.size[i].description);
    }
    return sizeName.toString();
  };

  const getPrice = () => {
    let price = "";
    for (let i = 0; i < props.item.size.length; i++) {
      if (props.item.size[i].isDefault) {
        price = props.item.size[i].price;
      }
    }
    return price;
  };

  const onBoarding = useSelector((state) => {
    return !isEmpty(state?.onboarding)
      ? state?.onboarding?.restaurantDetails
      : "";
  });

  const subscriptionStatus = useSelector((state) => {
    return !isEmpty(state?.onboarding)
      ? state?.onboarding?.onboard_subscription_details?.casual_dining
        ? state?.onboarding?.onboard_subscription_details?.casual_dining_status
        : state?.onboarding?.onboard_subscription_details?.fast_food_dining
        ? state?.onboarding?.onboard_subscription_details
            ?.fast_food_dining_status
        : state?.onboarding?.onboard_subscription_details
            ?.multi_service_business
        ? state?.onboarding?.onboard_subscription_details
            ?.multi_service_business_status
        : {}
      : {};
  });

  /*****************************
   * @DESC ACTIVE SERVICES
   *****************************/
  const [activeServiceArr, setActiveServiceArr] = useState();

  useEffect(() => {
    let data = [];
    if (subscriptionStatus?.ordering?.take_away?.value) {
      if (props?.item?.take_away?.value) {
        let value = "Take Away";
        data.push(value);
      }
    }
    if (subscriptionStatus?.ordering?.cubside_delivery?.value) {
      if (props?.item?.curb_side?.value) {
        let value = "Curb Side";
        data.push(value);
      }
    }
    if (subscriptionStatus?.ordering?.self_serve?.value) {
      if (props?.item?.skip_line?.value) {
        let value = "Skip The Line";
        data.push(value);
      }
    }
    if (subscriptionStatus?.ordering?.dine_in_order?.value) {
      if (props?.item?.dine_in?.value) {
        let value = "Dine In";
        data.push(value);
      }
    }
    if (subscriptionStatus?.ordering?.catering_banquet?.value) {
      if (props?.item?.catering_banquet?.value) {
        let value = "Catering";
        data.push(value);
      }
    }
    if (subscriptionStatus?.ordering?.home_delivery?.value) {
      if (props?.item?.home_delivery?.value) {
        let value = "Home Delivery";
        data.push(value);
      }
    }
    setActiveServiceArr(data);
  }, [subscriptionStatus, props?.item]);

  let activeServiceText =
    activeServiceArr && activeServiceArr.toString().replace(/,/gi, ", ");

  return (
    <React.Fragment>
      <Row className="f12-500 opacity5">
        <Col>
          <div>Item ID</div>
        </Col>
        <Col>
          <div>Item Name</div>
        </Col>
        <Col>
          <div>Item Category</div>
        </Col>
      </Row>
      <Row className="mt-2 f11-500">
        <Col>
          <div className="text-break">
            #ID{" "}
            {props && props.item && props.item.ext_id
              ? props.item.ext_id
              : props.item._id}
          </div>
        </Col>
        <Col>
          <div>
            <div className="d-flex">
              {/* Veg / Non veg icon */}
              {ITEMTYPEVEG.map((type, index) => {
                return (
                  <React.Fragment key={index}>
                    {props?.item?.itemType === type?.value ? (
                      <Image
                        width="20px"
                        height="20px"
                        src={type.url}
                        alt={type.title}
                        title={type.title}
                        // fluid
                      />
                    ) : null}
                  </React.Fragment>
                );
              })}{" "}
              <div className="ml-3">
                <ReadMore>{props && props.item && props.item.name}</ReadMore>
              </div>
            </div>
            <hr />
            <div className="d-flex">
              <Image
                src={
                  props &&
                  props.item &&
                  props.item.primary_food_type &&
                  props.item.primary_food_type.icon
                }
                alt={props?.item?.primary_food_type?.title}
                title={props?.item?.primary_food_type?.title}
                width="20px"
                height="20px"
                // fluid
              />
              <div className="ml-3">
                {props &&
                  props.item &&
                  props.item.primary_food_type &&
                  props.item.primary_food_type.title}
              </div>
            </div>
          </div>
        </Col>
        <Col>
          <div>
            <ReadMore
              children={props?.item?.category?.name}
              minLength={30}
              charLength={
                props?.item?.category?.name !== null &&
                props?.item?.category?.name !== undefined
                  ? props?.item?.category?.name.length
                  : 10
              }
            />
          </div>
        </Col>
      </Row>

      {/* Row 2 */}
      <Row className="mt-4 f12-500 opacity5">
        <Col>
          <div>Preparation Time</div>
        </Col>
        <Col>
          <div>Item Size</div>
        </Col>
        <Col>
          <div>Item Price</div>
        </Col>
      </Row>
      <Row className="mt-2 f12-500">
        <Col>
          <div>{props && props.item && props.item.prepTime} Mins</div>
        </Col>
        <Col>
          <div>
            <ReadMore
              children={getSizes()}
              minLength={30}
              charLength={
                getSizes() !== null && getSizes() !== undefined
                  ? getSizes().length
                  : 10
              }
            />
          </div>
        </Col>
        <Col>
          <div>₹ {getPrice()}</div>
        </Col>
      </Row>

      {/* Row 3 */}
      <Row className="mt-4 f12-500 opacity5">
        <Col>
          <div>Auto Accept</div>
        </Col>
        <Col>
          <div>Availability</div>
        </Col>
        <Col>
          <div>Active Services</div>
        </Col>
      </Row>
      <Row className="mt-2 f12-500">
        <Col>
          <div>
            {props && props.item && props.item.auto_accept ? "Yes" : "No"}
          </div>
        </Col>
        <Col>
          <div
            className={`${
              props && props.item && props.item.availability === "AVAILABLE"
                ? " badge badge-success"
                : props && props.item && props.item.availability === "SOLDOUT"
                ? " badge badge-danger"
                : " badge badge-dark"
            }`}
          >
            {props && props?.item && props?.item?.availability}
          </div>
        </Col>
        <Col>
          <div>
            <p className="d-flex" style={{ color: "#1396ff" }}>
              {activeServiceText && activeServiceText}
            </p>
          </div>
        </Col>
      </Row>

      {/* Row 4 */}
      <Row className="mt-4 f12-500 opacity5">
        <Col>
          <div>Description</div>
        </Col>
        <Col>
          <div>Status</div>
        </Col>
        <Col>
          <div>Item Tag</div>
        </Col>
      </Row>
      <Row className="mt-2 f12-500">
        <Col>
          <div>
            <ReadMore
              children={props.item.description}
              minLength={30}
              charLength={
                props.item.description !== null &&
                props.item.description !== undefined
                  ? props.item.description.length
                  : 10
              }
            />
          </div>
        </Col>
        <Col>
          <div>
            {props && props.item && props.item.status ? "Active" : "In Active"}
          </div>
        </Col>
        <Col>
          <div>
            {props &&
              props.item &&
              props.item.tags &&
              props.item.tags.map((tag, index) => (
                <Fragment key={index}>
                  {" "}
                  {tag.title} {index + 1 !== props.item.tags.length && ", "}
                </Fragment>
              ))}
          </div>
        </Col>
      </Row>
      {/* Row 5 */}
      <Row className="mt-4 f12-500 opacity5">
        <Col>
          <div>Cuisine Type</div>
        </Col>
        <Col>
          <div>No. Of Views</div>
        </Col>
        <Col>
          <div>Item Ordered</div>
        </Col>
      </Row>
      <Row className="mt-2 f12-500">
        <Col>
          <div>
            {" "}
            {props &&
              props.item &&
              props.item.cuisin_type &&
              props.item.cuisin_type.title}
          </div>
        </Col>
        <Col>
          <div>
            <i className="fa fa-eye"></i>{" "}
            {props && props.item && props.item.view_count}
          </div>
        </Col>
        <Col>
          <div>
            <SVG
              src={require("../../../../assets/images/Orders/icons/itemOrders.svg")}
              className="navigation-icon"
              alt="logo"
              width={14}
              height={14}
            />
            {props && props.item && props.item.order_count}
          </div>
        </Col>
      </Row>
      <Row className="mt-4 f12-500 opacity5">
        <Col>
          <div>More Actions</div>
        </Col>
      </Row>
      <Row className="mt-2">
        <Col>
          <div className="d-flex">
            <Button
              variant="link"
              className="enIconBtn mr-3"
              // onClick={() => {
              //   viewType(2);
              //   viewOrderInDetail();
              // }}
              onClick={() => props.takeToEditPage()}
            >
              <Image
                src={require("../../../../assets/images/UserManagement/pencil.svg")}
                alt="Edit"
                title="Edit"
                fluid
              />
            </Button>{" "}
            <Button
              variant="link"
              className="enIconBtn mr-3"
              onClick={() => props.handleshowItem()}
              // onClick={() => {
              //   viewType(1);
              //   viewOrderInDetail();
              // }}
            >
              <i
                className="fa fa-trash"
                style={{ color: "#000000" }}
                title="Delete"
              ></i>
            </Button>
          </div>
        </Col>
      </Row>
      <div className="mt-4 f12-500 ">
        <div className="opacity5 mb-2">Item Description</div>
        <p>{props && props.item && props.item.description}</p>
      </div>
      <div className="mt-4 f12-500">
        <div className="opacity5 mb-2">Ingredients Description</div>
        <p>{props && props.item && props.item.ingredient_description}</p>
      </div>
      <div className="mt-4 f12-500">
        <div className="opacity5 mb-2">Keywords</div>
        <p>
          {props &&
            props.item &&
            props.item.keywords &&
            props.item.keywords.toString()}
        </p>
      </div>

      <Row className="mt-4 f12-500 opacity5">
        {onBoarding?.nutrition_information ? (
          <Col>
            <div>Nutritional Info</div>
          </Col>
        ) : null}
        {onBoarding?.allergic_information ? (
          <Col>
            <div>Allergy Info</div>
          </Col>
        ) : null}
      </Row>
      <Row className="mt-2 f12-500">
        {onBoarding?.nutrition_information ? (
          <Col>
            <div>{props?.item?.details_nutritions?.value ? "Yes" : "No"}</div>
          </Col>
        ) : null}
        {onBoarding?.allergic_information ? (
          <Col>
            <div>{props?.item?.allergy_information.value ? "Yes" : "No"}</div>
          </Col>
        ) : null}
      </Row>
      <Row className="mt-4 f12-500 opacity5">
        {onBoarding?.personalization_information ? (
          <Col>
            <div>Personalization</div>
          </Col>
        ) : null}
        <Col>
          <div>IS Item Customizable</div>
        </Col>
      </Row>
      <Row className="mt-2 f12-500">
        {onBoarding?.personalization_information ? (
          <Col>
            <div>{props?.item?.personalization_status ? "Yes" : "No"}</div>
          </Col>
        ) : null}
        <Col>
          <div>{props?.item?.itemSize === "CUSTOM" ? "Yes" : "No"}</div>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default ItemDescModelBody;
